import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { convertApiItemResponseToItem } from '@shared/core/utils';
import { FormFieldOptions, FormFieldOptionsResponse } from '../form-fields';
import { CrmApiService } from '../../core/services/crm-api.service';

@Injectable({
  providedIn: 'root',
})
export class FormOptionsService extends CrmApiService {
  getOptions(path: string, cache = true): FormFieldOptions {
    return this.api.get<FormFieldOptionsResponse>(`${this.baseEndpoint}${path}`, { withCredentials: true, cache }).pipe(
      convertApiItemResponseToItem,
      catchError(() => of([])),
    );
  }
}
